module.exports = __webpack_public_path__ + "img/img_sfz3.4b22c45d.png";